import React, { useState } from "react";
import InternalStudyCoursesService from "@services/internal-study-courses-service";
import toast from "react-hot-toast";
import Dropzone from "@ui/dropzone/dropzone";
import { TextField, FormControlLabel, Checkbox } from "@mui/material";
import clsx from "clsx";
import style from "@scss/modals/company/create-company.module.scss";
import useModal from "@modals/modal-hook";
import useStyles from "@ui/material-ui-styles";

const EditInternalCourseLessonModal = () => {
  const { close, modalComponent, modalData } = useModal();
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const classes = useStyles();

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    const modalBtn = document.querySelector(
      "button.modal_btn"
    ) as HTMLButtonElement;
    modalBtn.disabled = true;

    const title = document.querySelector(
      'input[name="title"]'
    ) as HTMLInputElement;
    const days_disabled = document.querySelector(
      'input[name="days_disabled"]'
    ) as HTMLInputElement;
    const max_attempts_per_day = document.querySelector(
      'input[name="max_attempts_per_day"]'
    ) as HTMLInputElement;
    const sync = document.querySelector(
      'input[name="sync"]'
    ) as HTMLInputElement;

    const formData = new FormData();
    formData.append("title", title?.value);
    formData.append("days_disabled", days_disabled?.value);
    formData.append("max_attempts_per_day", max_attempts_per_day?.value);
    formData.append("sync", sync.checked ? "1" : "0");

    if (uploadedFiles.length) {
      formData.append("thumbnail", uploadedFiles[0]);
    }

    return InternalStudyCoursesService.updateLesson(
      modalData.id,
      formData,
      (err, res) => {
        if (err || !res) {
          if (err?.response?.status === 422) {
            modalBtn.disabled = false;
          }
          toast.error(`Ошибка при обновлении лекции "${modalData.title}"`);
        }

        close();
      }
    );
  };

  return (
    <div key={modalComponent.key} className={clsx(style.create_company_modal)}>
      <p className="modal_title">Редактировать лекцию "{modalData.title}"</p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <TextField
          name="title"
          label="Название"
          variant="filled"
          required
          defaultValue={modalData.title || ""}
          slotProps={{
            input: {
              autoComplete: "off",
            },
          }}
        />
        <TextField
          name="days_disabled"
          label="Дней до отключения"
          variant="filled"
          required
          defaultValue={modalData.days_disabled || ""}
          slotProps={{
            input: {
              autoComplete: "off",
            },
          }}
        />
        <TextField
          name="max_attempts_per_day"
          label="Кол-во попыток в день"
          variant="filled"
          required
          defaultValue={modalData.max_attempts_per_day || ""}
          slotProps={{
            input: {
              autoComplete: "off",
            },
          }}
        />
        <FormControlLabel
          control={
            <Checkbox name="sync" defaultChecked={modalData.sync === 1} />
          }
          name="sync"
          label="Синхронизировать автоматически"
        />
        <Dropzone
          withPreviews
          maxFiles={1}
          files={uploadedFiles}
          onUpload={(files) => setUploadedFiles(files)}
          onDeleteFile={() => setUploadedFiles([])}
          accept="image/jpeg, image/png"
          type={"course"}
        />
        <button type="submit" className="modal_btn">
          {modalComponent.btnText}
        </button>
      </form>
    </div>
  );
};

export default EditInternalCourseLessonModal;
